module.exports = __webpack_public_path__ + "img/mnemo.88dd3005.jpg";